import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('StarterPackShopFrame').create(() => ({
  root: {
    position: 'relative',
    width: '100%',
    height: '164px',
    padding: '4px',
    marginTop: '36px',
    background: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid',
    borderRadius: '12px',
    cursor: 'pointer',
    borderColor: 'rgba(255, 255, 255, 0.09)',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '12px',
      backgroundImage: 'url("https://storage.googleapis.com/gamed-games-bucket/pictures/cases-and-rewards/shop-special-offer-bg.png")',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      opacity: 0.5,
      zIndex: 0,
    },
    zIndex: 1,
  },

  imageWrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    top: '-78px',
  },

  packImage: {
    height: '196px',
    transform: 'rotate(-25deg)',
  },

  discountContainer: {
    position: 'absolute',
    top: '36px',
    left: '50%',
    transform: 'translateX(40px) rotate(-20deg)',

    width: '72px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.6)',
    borderRadius: '20px',
  },

  discountText: {
    fontWeight: 700,
    fontFamily: 'Space Grotesk',
    fontSize: '20px',
    color: 'white',
  },

  textAndTimeWrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'center',
    position: 'absolute',
    bottom: '8px',
  },

  timeLeftWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },

  expiresText: {
    fontSize: '13px',
    fontWeight: 250,
    color: '#ccc',
  },

  timeLeftContainer: {
    display: 'flex',
    gap: '8px',
  },

  daysWrapper: {
    background: '#111',
    padding: '4px 6px',
    display: 'flex',
    borderRadius: '4px',
    boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 1) inset, 0px 1px 0px 0px rgba(72, 72, 72, 1)',

    span: {
      fontWeight: 400,
      fontFamily: 'Space Grotesk, Inter',
      fontSize: '18px',
      color: 'white',
    },
  },

  heading: {
    color: 'white',
    textAlign: 'center',
    fontSize: '24px',
    fontWeight: 450,
  },
}))
